
const tokenstore = (value)=>{
  localStorage.setItem('Oneuptoken4',JSON.stringify(value))
}
const tokenvoucher = (value)=>{
  localStorage.setItem('vouchercode',JSON.stringify(value))
}
const shippingquestion = (value)=>{
  localStorage.setItem('yesorno',JSON.stringify(value))
}
const recentlystore = (value)=>{
  localStorage.setItem('recently16',JSON.stringify(value))
}
const bulkrecentlystore = (value)=>{
  localStorage.setItem('bulkrecently16',JSON.stringify(value))
}
const freezrorderstore = (value)=>{
  localStorage.setItem('freeze',JSON.stringify(value))
}
const shippinfidstore = (value)=>{
  localStorage.setItem('shipping',JSON.stringify(value))
}
const bulk = (value)=>{
  localStorage.setItem('bulk',JSON.stringify(value))
}

const getfreeze = ()=>{
  let data = localStorage.getItem('freeze')
  return JSON.parse(data)
}
const getrecetly = ()=>{
  let data = localStorage.getItem('recently16')
  return JSON.parse(data)
}
const getbulkrecetly = ()=>{
  let data = localStorage.getItem('bulkrecently16')
  return JSON.parse(data)
}
const getshippingquestion = ()=>{
  let data = localStorage.getItem('yesorno')
  return JSON.parse(data)
}
const gettoken = ()=>{
  let data = localStorage.getItem('Oneuptoken4')
  return JSON.parse(data)
}
const getshipping = ()=>{
  let data = localStorage.getItem('shipping')
  return JSON.parse(data)
}
const getvoucher = ()=>{
  let data = localStorage.getItem('vouchercode')
  return JSON.parse(data)
}
const getbulk = ()=>{
  let data = localStorage.getItem('bulk')
  return JSON.parse(data)
}

 const removeToken = ()=>{
  localStorage.removeItem('Oneuptoken4')
  localStorage.removeItem('vouchercode')
  localStorage.removeItem('bulk')
    }
 const removefreeze = ()=>{
  localStorage.removeItem('freeze')
    }
 const recentitemremove = ()=>{
  localStorage.removeItem('recently16')
    }
 const bulkrecentitemremove = ()=>{
  localStorage.removeItem('bulkrecently16')
    }
 const shippingidremove = ()=>{
  localStorage.removeItem('shipping')
    }
 const shippingquestionremove = ()=>{
  localStorage.removeItem('yesorno')
    }
 const removebulk = ()=>{
  localStorage.removeItem('bulk')
    }

  export {tokenstore,gettoken,removeToken,getrecetly,recentlystore,getvoucher,tokenvoucher,removefreeze,getfreeze,freezrorderstore,recentitemremove,shippinfidstore,getshipping, shippingidremove,shippingquestionremove,getshippingquestion,shippingquestion,removebulk,getbulk,bulk,bulkrecentlystore,getbulkrecetly,bulkrecentitemremove }

  